export var EventDetailsSuccessActions = {
    CHECK_IN_EVENT: 'check_in_event',
    APPROVE_EVENT: 'approved_event',
    REJECT_EVENT: 'rejected_event',
    DELETE_EVENT: 'deleted_event',
    REMOVE_SPACE_INVITEE: 'removed_space_invitee',
    RSVP_EVENT: 'rsvp_event',
    MOVED_ORGANIZER_SPACE: 'moved_organizer_space',
};
